import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {RootState} from '../app/rootReducer';
import {countryChanged} from './countryChanged';

export interface TourState {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
  error: string | null;
  isLoading: boolean;
}

const initialState = {data: [], error: null, isLoading: false} as TourState;
const tourSlice = createSlice({
  name: 'tour',
  initialState,
  reducers: {
    getTours(state, _action) {
      state.isLoading = true;
    },
    getToursSuccess(state, action) {
      state.data = action.payload;
      state.isLoading = false;
    },
    getToursError(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.isLoading = false;
    },
    addTours(state, _action) {
      state.data = [];
    },
  },
  extraReducers: builder => {
    // Al cambiar de país, limpiar el recorrido mostrado (vuelve al EmptyRouteIcon).
    builder.addCase(countryChanged, () => initialState);
  },
});

export const getToursSelector = (state: RootState) => state.tour.data;
export const isTourLoading = state => state.tour.isLoading;
export const getErrorSelector = state => state.tour.error;

export default tourSlice.reducer;
export const {getTours, getToursSuccess, getToursError, addTours} =
  tourSlice.actions;
